import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { addPartnerOption } from 'constants/addPartnerOption';

import MandatoryField from 'modules/_shared/components/MandatoryField';
import IconTooltip from 'modules/_shared/components/Icon/IconTooltip';
import CustomAsyncSelect from 'modules/_shared/components/CustomAsyncSelect';

import { useSharesTransferModal } from '../context/SharesTransferModalContext';
import AddPartnerEmbeddedModal from '../../AddPartnerEmbedded';

const SharesTransferModalPartnersSection: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useSharesTransferModal();

  const { modalLabels } = data;

  const handleSearchPartnerSellerByTerm = async (searchTerm: string) => {
    const options = await actions.handleSearchPartnerByTerm(searchTerm, true);
    return options;
  };

  const handleSearchPartnerBuyerByTerm = async (searchTerm: string) => {
    const options = await actions.handleSearchPartnerByTerm(searchTerm);
    return options;
  };

  return (
    <>
      <div className="form-group">
        <label className="form-label d-flex w-100 justify-content-between">
          <span className="d-flex align-items-start">
            {t(modalLabels.transmittingPartner)} <MandatoryField />
            <IconTooltip
              id="info-seller-partner"
              tooltip={t('OnlyPartnersWithSharesAreEligible')}
            />
          </span>
        </label>
        <div className="form-control-wrap">
          <CustomAsyncSelect
            id="partner-seller-select-input"
            onChange={actions.handleChangePartnerSeller}
            onFetchData={handleSearchPartnerSellerByTerm}
            value={data.selectedPartnerSellerOption}
            placeholder={t('SearchPartner')}
            minimumInputLength={3}
            noDataLabelKey="NoPartnersHaveBeenFound"
            loadingLabelKey="LoadingPartners"
            errorLabelKey="ErrorLoadingPartners"
            defaultOptions={data.partnerSellerOptions}
          />
        </div>
      </div>

      {!data.showAddPartnerSection ? (
        <div className="form-group">
          <label className="form-label">
            {t(modalLabels.recipientPartner)} <MandatoryField />
          </label>
          <CustomAsyncSelect
            id="partner-buyer-select-input"
            onChange={actions.handleChangePartnerBuyer}
            onFetchData={handleSearchPartnerBuyerByTerm}
            value={data.selectedPartnerBuyerOption}
            placeholder={t('SearchPartner')}
            minimumInputLength={3}
            noDataLabelKey="NoPartnersHaveBeenFound"
            loadingLabelKey="LoadingPartners"
            errorLabelKey="ErrorLoadingPartners"
            defaultOptions={data.partnerBuyerOptions}
            addOption={{
              ...addPartnerOption,
              label: `+ ${t(addPartnerOption.label)}`,
            }}
          />
        </div>
      ) : (
        <AddPartnerEmbeddedModal
          onCreate={actions.handleAddPartner}
          onClose={actions.handleCloseAddPartnerSection}
          date={data.date}
        />
      )}
    </>
  );
};

export default SharesTransferModalPartnersSection;
